let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4AbT1")).then(() => parcelRequire('ehwUR'));